import { Link, useLocation } from "react-router-dom";
import { BookOpen, Home } from "lucide-react";

export default function Header() {
  const loc = useLocation();
  const isShare = loc.pathname.startsWith("/share/");
  const isHome = loc.pathname === "/";
  return (
    <header
      className="sticky top-0 z-40 border-b-2 border-slate-200 bg-bone/95 backdrop-blur"
      data-testid="app-header"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link
          to={isShare ? "#" : "/"}
          className="group flex items-center"
          data-testid="nav-home-link"
          aria-label="LetterLifts — Snap it. Hear it. Handle it."
          onClick={(e) => { if (isShare) e.preventDefault(); }}
        >
          <img
            src="/letterlifts-logo.png"
            alt="LetterLifts — Snap it. Hear it. Handle it."
            className="h-32 sm:h-40 lg:h-48 w-auto transition-transform group-hover:scale-[1.02]"
          />
        </Link>
        {!isShare && (
          <nav className="flex items-center gap-3" aria-label="Primary">
            {!isHome && (
              <Link
                to="/"
                data-testid="nav-home-button"
                className="inline-flex items-center gap-2 rounded-full border-2 border-navy px-5 py-2 text-base font-semibold text-navy hover:bg-navy hover:text-bone transition-colors"
                aria-label="Go to home"
              >
                <Home strokeWidth={2.5} className="h-4 w-4" />
                Home
              </Link>
            )}
            <Link
              to="/my-letters"
              data-testid="nav-care-binder-link"
              className="hidden sm:inline-flex items-center gap-2 rounded-full border-2 border-slate-300 px-5 py-2 text-base font-semibold text-slate-800 hover:border-moss-700 hover:text-moss-700 transition-colors"
            >
              <BookOpen strokeWidth={2.5} className="h-4 w-4" />
              Care Binder
            </Link>
            <Link
              to="/upload"
              data-testid="nav-upload-link"
              className="hidden sm:inline-flex items-center gap-2 rounded-full border-2 border-moss-700 px-5 py-2 text-base font-semibold text-moss-700 hover:bg-moss-700 hover:text-bone transition-colors"
            >
              Upload a Letter
            </Link>
          </nav>
        )}
        {isShare && (
          <span
            className="rounded-full bg-moss-700 px-4 py-2 text-xs font-bold uppercase tracking-[0.14em] text-bone"
            data-testid="share-badge"
          >
            Trusted Support View
          </span>
        )}
      </div>
    </header>
  );
}
